import { mutate as gmutate, type MutatorOptions, type Arguments } from 'swr';

/** Mutation helper with `includes` coincidences. It will match url substrings */
export function mutate(url: string) {
  return gmutate(
    (key) => {
      if (typeof key === 'string' && key.includes(url)) return true;
      if (Array.isArray(key))
        return key.some(
          (param) => typeof param === 'string' && param.includes(url)
        );
      if (typeof key === 'object' && key && 'url' in key)
        return typeof key.url === 'string' ? key.url.includes(url) : false;
      return false;
    },
    (data) => data,
    { revalidate: true }
  );
}

/**
 * Differently from the first global mutate, this does not check if the string is present in the key.
 * This will search for the exact url used in SWR.
 * @param url Exact url key used in hook. Will perform === check
 * @returns Promise with mutation result
 */
export function strictMutate<T>(url: string, options: MutatorOptions<T> = {}) {
  return gmutate<T>(
    (key) => {
      const m = checkStrictMutation(key, url);
      // console.log(key, m);  // Used to debug
      return m;
    },
    (data) => data,
    { revalidate: true, ...options }
  );
}

function checkStrictMutation(key: Arguments, url: string) {
  if (typeof key === 'string' && key === url) return true;
  if (Array.isArray(key))
    return key.some((param) => typeof param === 'string' && param === url);
  if (typeof key === 'object' && key && 'url' in key) return key.url === url;
  return false;
}
